module.exports = __webpack_public_path__ + "img/common-file-sync.63e24c3c.svg";